import { SentimentName } from 'generated/graphql';

export const getSentimentNameFromDisplayName = (
  displayName: string | undefined,
) => {
  switch (displayName?.toLowerCase()) {
    case 'positive':
      return SentimentName.Positive;
    case 'neutral':
      return SentimentName.Neutral;
    case 'negative':
      return SentimentName.Negative;
    default:
      return SentimentName.Invalid;
  }
};
